module.exports = __webpack_public_path__ + "static/media/icon-apple-podcast.27606745.svg";